import { render, staticRenderFns } from "./TabHeaderLink.vue?vue&type=template&id=95ab6a40&scoped=true"
import script from "./TabHeaderLink.vue?vue&type=script&lang=js"
export * from "./TabHeaderLink.vue?vue&type=script&lang=js"
import style0 from "./TabHeaderLink.vue?vue&type=style&index=0&id=95ab6a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ab6a40",
  null
  
)

export default component.exports